import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import { CartItemPreview as CartItem } from "./CartItemPreview";
import Modal from '../modal/Modal';
import GoBack from './LocationRouter';
import { useHistory } from 'react-router-dom';
import { SitecoreLink } from '../link/Link';
import { useFlags } from 'launchdarkly-react-client-sdk'; //ga tracker

import gaTracker from '../../util/ga-analytics/gaTracker';
import { Upsell } from "../upsell/Upsell";
import { getSessionStorageKey } from '../../util';
export var Preview = function Preview(props) {
  var newItem = props.newItem,
      items = props.items,
      addTo = props.addTo,
      _props$close = props.close,
      close = _props$close === void 0 ? function () {
    return "";
  } : _props$close,
      isEdit = props.isEdit,
      upsellInfo = props.upsellInfo,
      _props$isCart = props.isCart,
      isCart = _props$isCart === void 0 ? false : _props$isCart,
      _props$store = props.store,
      store = _props$store === void 0 ? {} : _props$store;
  var path = typeof window === 'undefined' ? '' : window.location.pathname;
  var firstPath = path.split("/")[1] || 'menu';
  var href = typeof window === 'undefined' ? '' : window.location.href;
  var productpage = href.includes('?productid');
  var history = useHistory();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      redirectToCart = _useState2[0],
      setRedirectToCart = _useState2[1];

  var flags = useFlags();
  var useNewRebrandStyles = flags['releaseRebrandDstr6457'] || false;

  var cartClick = function cartClick() {
    var data = {
      gtm: {
        uniqueEventId: 95,
        elementId: "preview-viewcart",
        elementText: "View Cart & Checkout"
      },
      event: 'gtm.click'
    };
    close();
    gaTracker(data);
  };

  var shoppingClick = function shoppingClick() {
    var data = {
      gtm: {
        uniqueEventId: 94,
        elementId: "preview-keepshopping",
        elementText: "Keep Shopping"
      },
      event: 'gtm.click'
    };
    close();
    gaTracker(data);
    setRedirectToCart(true);
  };

  var refreshCart = function refreshCart() {
    close(); // history.push('/cart')
    //window.location.reload()
  };

  useEffect(function () {
    if (addTo === false && redirectToCart) {
      var interval = setInterval(function () {
        var cart = getSessionStorageKey('cart');

        if (cart.addedToCart === false) {
          clearInterval(interval);
          setRedirectToCart(false);
          window.location.href = '/cart';
        }
      }, 100);
      return function () {
        return clearInterval(interval);
      }; // Cleanup interval on component unmount
    }
  }, [addTo, redirectToCart]);
  return /*#__PURE__*/React.createElement(Modal, {
    className: "cb-menu-secondary cb-z-index-1",
    show: addTo,
    hide: close,
    exited: close,
    hideCloseButton: true,
    style: {
      zIndex: 9999
    },
    title: isEdit ? "You've successfully updated an item in your cart" : "You've added an item to your cart!",
    titleSize: "sm",
    titleColor: useNewRebrandStyles ? "cb-brown" : "red-900"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-cart__preview__lower"
  }, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(CartItem, _extends({
      key: index
    }, item));
  }), !Boolean(isCart) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Upsell, {
    fields: upsellInfo,
    onClick: close,
    store: store
  }), Boolean(productpage) && /*#__PURE__*/React.createElement(GoBack, {
    onClick: cartClick
  }), Boolean(!productpage) && /*#__PURE__*/React.createElement("a", {
    className: "cb-button-secondary",
    id: "preview-keepshopping",
    onClick: cartClick
  }, "Keep Shopping"), /*#__PURE__*/React.createElement("a", {
    className: "cb-button-primary",
    id: "preview-viewcart",
    onClick: shoppingClick
  }, "View Cart & Checkout")) : /*#__PURE__*/React.createElement("a", {
    className: "cb-button-secondary",
    id: "preview-keepshopping",
    onClick: refreshCart,
    href: "#"
  }, "Back to cart"), /*#__PURE__*/React.createElement("span", {
    className: "cartsubtotal visuallyhidden"
  }, newItem === null || newItem === void 0 ? void 0 : newItem.total), /*#__PURE__*/React.createElement("span", {
    className: "displayname visuallyhidden"
  }, newItem === null || newItem === void 0 ? void 0 : newItem.displayName), /*#__PURE__*/React.createElement("span", {
    className: "productid visuallyhidden"
  }, newItem === null || newItem === void 0 ? void 0 : newItem.storeProductId)));
};